import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const myApplicationSlide = createSlice({
    name: "myApplication",
    initialState: {
        applicationList: [],
        applicationListPage: 0,
        applicationListPageCount: 0,
        applicationDetail: null,

        applicationSuccess: false,
        applicationFail: false,
        applicationErrorDetail: null,

        updateApplicationSuccess: false,
        updateApplicationFail: false,
        updateApplicationErrorDetail: null,
    },
    reducers: {
        doGetApplicationListSuccess: (state, action) => {
            state.applicationList = action.payload.data;
            state.applicationListPage = action.payload.current_page;
            state.applicationListPageCount = action.payload.page_count;
        },
        doGetApplicationListFail: (state, action) => {
            state.applicationList = [];
            state.applicationListPage = 0;
            state.applicationListPageCount = 0;
        },
        doGetApplicationDetailSuccess: (state, action) => {
            state.applicationDetail = action.payload.data;
        },
        doGetProductDetailFail: (state, action) => {
            state.applicationDetail = null;
        },
        resetApplicationState: (state, action) => {
            state.applicationList = [];
            state.applicationListPage = 0;
            state.applicationListPageCount = 0;
            state.applicationDetail = null;
            state.applicationSuccess = false;
            state.applicationFail = false;
            state.applicationErrorDetail = null;
        },
        doApplicationSuccess: (state, action) => {
            state.applicationSuccess = true;
            state.applicationFail = false;
            state.applicationErrorDetail = null;
        },
        doApplicationFail: (state, action) => {
            state.applicationSuccess = false;
            state.applicationFail = true;
            state.applicationErrorDetail = action.payload;
        },
        doUpdateApplicationSuccess: (state, action) => {
            state.updateApplicationSuccess = true;
            state.updateApplicationFail = false;
            state.updateApplicationErrorDetail = null;
        },
        doUpdateApplicationFail: (state, action) => {
            state.updateApplicationSuccess = false;
            state.updateApplicationFail = true;
            state.updateApplicationErrorDetail = action.payload.data;
        },
        resetUpdateApplicationState: (state, action) => {
            state.updateApplicationSuccess = false;
            state.updateApplicationFail = false;
            state.updateApplicationErrorDetail = null;
        },
    },
});

export const doGetApplicationList = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/my_application?page=${param.page}&size=${param.limit}`;
        const response = await axios.get(url);
        dispatch(doGetApplicationListSuccess(response.data));
    } catch (error) {
        dispatch(doGetApplicationListFail(error.response));
    }
};

export const doGetApplicationDetail = (param) => async (dispatch) => {
    try {
        const url = `/api/customer/my_application/${param.customer_enquiries_id}`;
        const response = await axios.get(url, param);

        dispatch(doGetApplicationDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetProductDetailFail(error.response));
    }
};

export const doResetApplicationState  = () => async (dispatch) => {
    dispatch(resetApplicationState());
};
export const doUpdateApplication = (customerEnquiriesId, param, SSMFileValue, SSTFileValue, businessCardFileValue) => async (dispatch) => {
	try {
        let formData = new FormData();

        for (const field in param) {
            const value = param[field];

            if (value !== null && value !== '') {
                formData.append(
                    field, value
                );
            }
        }

        if (SSMFileValue.length > 0) {
            SSMFileValue.forEach((file, index) => {
                formData.append(`ssm_file`, file);
            });
        }

        if (SSTFileValue.length > 0) {
            SSTFileValue.forEach((file, index) => {
                formData.append(`sst_file`, file);
            });
        }

        if (businessCardFileValue.length > 0) {
            businessCardFileValue.forEach((file, index) => {
                formData.append(`business_card_file`, file);
            });
        }

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        const url = `/api/customer/my_application/${customerEnquiriesId}`;    

        const response = await axios.put(url, formData, config);

        dispatch(doUpdateApplicationSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateApplicationFail(error.response));
    }
};

export const doResetUpdateApplicationState = () => async (dispatch) => {
    dispatch(resetUpdateApplicationState());
};

export const { 
    doGetApplicationListSuccess,
    doGetApplicationListFail,
    doGetApplicationDetailSuccess,
    doGetProductDetailFail,
    resetApplicationState,
    doApplicationSuccess,
    doApplicationFail,
    doUpdateApplicationSuccess,
    doUpdateApplicationFail,
    resetUpdateApplicationState,
} = myApplicationSlide.actions;

export const getApplicationList = (state) => state.myApplication?.applicationList;
export const getApplicationListPage = (state) => state.myApplication?.applicationListPage;
export const getApplicationListPageCount = (state) => state.myApplication?.applicationListPageCount;

export const getApplicationDetail = (state) => state.myApplication?.applicationDetail;

export const getApplicationSuccess = (state) => state.myApplication?.applicationSuccess;
export const getApplicationFail = (state) => state.myApplication?.applicationFail;
export const getApplicationErrorDetail = (state) => state.myApplication?.applicationErrorDetail;

export const getUpdateApplicationSuccess = (state) => state.myApplication?.updateApplicationSuccess;
export const getUpdateApplicationFail = (state) => state.myApplication?.updateApplicationFail;
export const getUpdateApplicationErrorDetail = (state) => state.myApplication?.updateApplicationErrorDetail;


export default myApplicationSlide.reducer;
